import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { grammarPointSummarySchema } from '../schemas';

const getGrammarNextPointV1DataSchemaDefinition = z.object({
  point: grammarPointSummarySchema.nullable(),
  why: z.enum(['overdue', 'new', 'fading']).nullable(),
  dueCount: z.number().int(),
  newAvailableCount: z.number().int(),
});

export const getGrammarNextPointV1DataSchema: typeof getGrammarNextPointV1DataSchemaDefinition =
  getGrammarNextPointV1DataSchemaDefinition;

export type IGetGrammarNextPointV1Data = z.infer<typeof getGrammarNextPointV1DataSchema>;

export type GrammarNextPointWhyType = NonNullable<IGetGrammarNextPointV1Data['why']>;

export const getGrammarNextPointV1ResponseSchema: z.ZodSchema<IAPI<IGetGrammarNextPointV1Data>> =
  createApiResponseSchema(getGrammarNextPointV1DataSchema) as z.ZodSchema<
    IAPI<IGetGrammarNextPointV1Data>
  >;

export type IGetGrammarNextPointV1Response = IAPI<IGetGrammarNextPointV1Data>;
